import { render } from "./participantModalList.vue?vue&type=template&id=505c64be&ts=true"
import script from "./participantModalList.vue?vue&type=script&lang=ts"
export * from "./participantModalList.vue?vue&type=script&lang=ts"

import exportComponent from "/home/jenkins/agent/workspace/IT_CICD/SDK/Prod/Joymeet_frontend/GUI/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__